/* AGS Fast Pass in the Zipify (OneClickUpsell) slide cart — v18 2026-10-17, v19 2026-10-17, v20 2026-10-23 (wording: skip the production line).
 *
 * v19 (owner): the box under the lines sits in the scroll area and can be missed, so a one-line
 * checkbox row "Add Fast Pass – $39" is also drawn in the sticky footer, just above Checkout.
 * Ticking adds Fast Pass; unticking removes it. Same metal-only rule as the box.
 *
 * The slide cart on this site is Zipify's drawer (class prefix "ocu-"), not the theme's ajax cart,
 * so the v9 Fast Pass box (ajax-cart.js.liquid) never showed there and its one-per-order rules never
 * ran there. This file reuses window.AGSFastPass (defined in ajax-cart.js, loaded on every page):
 *   - Box under the cart lines when the cart holds a metal item: "Made to order – ships within 7 days"
 *     + [Add Fast Pass – $39]; with Fast Pass in the cart: "Fast Pass added".
 *   - Rules after every drawer redraw and on page load: Fast Pass with no metal item is removed;
 *     more than one is set back to 1. The drawer is then refreshed with window.SLIDECART_UPDATE().
 *   - The Fast Pass line's quantity box is hidden.
 * Off until the Fast Pass product is Active (AGSFastPass.config() resolves null otherwise).
 * Loaded on every page from layout/theme.liquid.
 */
(function () {
  var busy = false, queued = false, lastSig = '';

  function FP() { return window.AGSFastPass; }
  function refresh() {
    if (typeof window.SLIDECART_UPDATE === 'function') { try { window.SLIDECART_UPDATE(); } catch (e) {} }
  }
  function css() {
    if (document.getElementById('ags-fp-drawer-css')) return;
    var s = document.createElement('style');
    s.id = 'ags-fp-drawer-css';
    s.textContent =
      '.ags-fp-drawer{border:1px solid #cfdfe2;background:#f4f9fa;border-radius:6px;padding:12px 14px;margin:10px 16px;font-size:14px;line-height:1.45;color:#1f2a2e;text-align:left}' +
      '.ags-fp-drawer p{margin:0 0 6px}' +
      '.ags-fp-drawer--on{border-color:#0f5f68}' +
      '.ags-fp-drawer__btn{display:inline-block;margin-top:4px;padding:8px 14px;border:1px solid #0f5f68;background:#fff;color:#0f5f68;border-radius:4px;font-weight:700;font-size:14px;cursor:pointer}' +
      '.ags-fp-drawer__btn[disabled]{opacity:.6;cursor:wait}' +
      '.ags-fp-drawer__err{color:#b3261e;font-size:13px;margin-top:6px}' +
      '.ags-fp-row{display:flex;align-items:center;gap:10px;border:2px solid #0f5f68;background:#f4f9fa;border-radius:6px;padding:9px 12px;margin:0 0 10px;font-size:14px;line-height:1.3;color:#1f2a2e;cursor:pointer;text-align:left}' +
      '.ags-fp-row input{width:20px;height:20px;margin:0;flex:0 0 auto;accent-color:#0f5f68;cursor:pointer}' +
      '.ags-fp-row strong{color:#0f5f68}' +
      '.ags-fp-row--busy{opacity:.6;cursor:wait}';
    document.head.appendChild(s);
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function boxHtml(a, c) {
    if (a.fp) return '<div class="ags-fp-drawer ags-fp-drawer--on" data-ags-fp-drawer><p><strong>&#10003; Fast Pass added.</strong> Your order skips the production line and can ship as soon as the 2nd production day.</p></div>';
    return '<div class="ags-fp-drawer" data-ags-fp-drawer>' +
      '<p><strong>Made to order &ndash; ships within 7 days.</strong></p>' +
      '<p>Need it sooner? With Fast Pass, your order skips the production line and can ship as soon as the 2nd production day.</p>' +
      '<button type="button" class="ags-fp-drawer__btn" data-ags-fp-drawer-add>Add Fast Pass &ndash; ' + money(c.price) + '</button>' +
      '</div>';
  }
  function draw(a, c) {
    drawRow(a, c);
    var list = document.querySelector('.ocu-cart-drawer .ocu-cart-line-items');
    var old = document.querySelectorAll('[data-ags-fp-drawer]');
    var html = a.metal ? boxHtml(a, c) : '';
    var same = old.length === 1 && html && old[0].outerHTML === html.replace('data-ags-fp-drawer>', 'data-ags-fp-drawer="">');
    if (!same) {
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
      if (list && html) { css(); list.insertAdjacentHTML('afterend', html); }
    }
    if (a.fp) {
      var w = document.querySelector('.ocu-cart-line-item-wrapper[data-key="' + a.fp.key + '"]');
      if (w) {
        var q = w.querySelectorAll('.ocu-quantity');
        for (var j = 0; j < q.length; j++) q[j].style.display = 'none';
      }
    }
  }
  function rowHtml(a, c) {
    return '<label class="ags-fp-row" data-ags-fp-row>' +
      '<input type="checkbox" data-ags-fp-row-box' + (a.fp ? ' checked' : '') + '>' +
      '<span><strong>Add Fast Pass &ndash; ' + money(c.price) + '</strong> &middot; skip the production line</span>' +
      '</label>';
  }
  function drawRow(a, c) {
    var ctas = document.querySelector('.ocu-cart-drawer .cart__ctas');
    var old = document.querySelectorAll('[data-ags-fp-row]');
    var want = a.metal ? rowHtml(a, c) : '';
    if (old.length === 1 && want) {
      var box = old[0].querySelector('input');
      if (box && box.checked === !!a.fp && !old[0].classList.contains('ags-fp-row--busy')) return;
    }
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    if (ctas && want) { css(); ctas.insertAdjacentHTML('beforebegin', want); }
  }
  function run() {
    queued = false;
    var fp = FP();
    if (!fp || busy) return;
    busy = true;
    fp.config().then(function (c) {
      if (!c) { busy = false; return; }
      return fp.getCart().then(function (cart) {
        return fp.fix(cart).then(function (changed) {
          busy = false;
          if (changed) { lastSig = ''; refresh(); return; }
          draw(fp.analyse(cart), c);
        });
      });
    }).catch(function () { busy = false; });
  }
  function sig() {
    var w = document.querySelectorAll('.ocu-cart-drawer .ocu-cart-line-item-wrapper');
    var s = '';
    for (var i = 0; i < w.length; i++) s += (w[i].getAttribute('data-key') || '') + '|';
    var cnt = document.querySelector('.ocu-cart-header--items-count');
    return s + '#' + (cnt ? cnt.textContent : '') + '#' + (document.querySelector('[data-ags-fp-drawer]') ? 1 : 0) +
      (document.querySelector('[data-ags-fp-row]') ? 1 : 0) +
      (document.querySelector('.ocu-cart-drawer .cart__ctas') ? 1 : 0);
  }
  function check() {
    var s = sig();
    if (s === lastSig) return;
    lastSig = s;
    if (!queued) { queued = true; setTimeout(run, 150); }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ags-fp-drawer-add]') : null;
    if (!btn || !FP()) return;
    e.preventDefault();
    btn.disabled = true;
    FP().add().then(function () { lastSig = ''; refresh(); }).catch(function () {
      btn.disabled = false;
      btn.insertAdjacentHTML('afterend', '<p class="ags-fp-drawer__err">Fast Pass could not be added. Please try again.</p>');
    });
  });

  document.addEventListener('change', function (e) {
    var box = e.target && e.target.matches && e.target.matches('[data-ags-fp-row-box]') ? e.target : null;
    if (!box || !FP()) return;
    var row = box.closest('[data-ags-fp-row]');
    if (row) row.classList.add('ags-fp-row--busy');
    box.disabled = true;
    (box.checked ? FP().add() : FP().remove()).then(function () { lastSig = ''; refresh(); }).catch(function () {
      box.checked = !box.checked; box.disabled = false;
      if (row) row.classList.remove('ags-fp-row--busy');
    });
  });

  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(check).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
